import React from "react"
import PropTypes from "prop-types"
import { Title } from "shared/Components/Article/Title"
import { HeaderInfo } from "shared/Components/Article/HeaderInfo"
import { BiographySection } from "shared/UI/BiographySection"
import { HeaderPositioner } from "shared/Components/Article/HeaderPositioner"
import { ARTICLE_HEADER_POSITIONS } from "App/modules/articles/articles"
import get from "lodash/get"

import "./style.css.scss"

const Article = (props) => {
  const article = props.item.article
  const authorUser = {
    id: article.author_user.id,
    name: article.author_user.name,
    image: article.author_user.image
  }

  const articleHeaderPosition = get(
    article,
    "header_settings.position",
    ARTICLE_HEADER_POSITIONS.top
  )

  const renderArticleHeader = () => (
    <HeaderInfo
      article={article}
      authors={[authorUser]}
      readOnly={props.readOnly}
    />
  )

  const renderArticleTitle = () => (
    <Title title={article.title} readOnly={props.readOnly} />
  )

  return (
    <article className="article-content-container">
      <HeaderPositioner
        articleHeaderPosition={articleHeaderPosition}
        renderArticleTitle={renderArticleTitle}
        renderArticleHeader={renderArticleHeader}
      />
      <div className="ql-container ql-bubble">
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: article.body }}
        />
      </div>
      {article.bio_settings.should_display && (
        <div className="bio-area">
          <BiographySection author={article.author_user} />
        </div>
      )}
    </article>
  )
}

Article.propTypes = {
  article: PropTypes.object,
  readOnly: PropTypes.bool
}

Article.defaultProps = {
  readOnly: true
}

export default Article